module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unitsList"
  }, [(!_vm.isLoading) ? _c('div', [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle boldTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), (_vm.bindings.height) ? _c('mu-card-text', [_c('tab-selector', {
    attrs: {
      "label": _vm.$t('message.unitsPreferencesMeasureWeight'),
      "list": _vm.bindings.weight,
      "text-key": "unit",
      "value-key": "preference_id"
    },
    model: {
      value: (_vm.model.weight),
      callback: function($$v) {
        _vm.$set(_vm.model, "weight", $$v)
      },
      expression: "model.weight"
    }
  }), _vm._v(" "), _c('tab-selector', {
    attrs: {
      "label": _vm.$t('message.unitsPreferencesMeasureHeight'),
      "list": _vm.bindings.height,
      "text-key": "unit",
      "value-key": "preference_id"
    },
    model: {
      value: (_vm.model.height),
      callback: function($$v) {
        _vm.$set(_vm.model, "height", $$v)
      },
      expression: "model.height"
    }
  }), _vm._v(" "), _c('tab-selector', {
    attrs: {
      "label": _vm.$t('message.unitsPreferencesMeasureWaist'),
      "list": _vm.bindings.waist,
      "text-key": "unit",
      "value-key": "preference_id"
    },
    model: {
      value: (_vm.model.waist),
      callback: function($$v) {
        _vm.$set(_vm.model, "waist", $$v)
      },
      expression: "model.waist"
    }
  }), _vm._v(" "), _c('tab-selector', {
    attrs: {
      "label": _vm.$t('message.unitsPreferencesMeasureHba1c'),
      "list": _vm.bindings.hba1c,
      "text-key": "unit",
      "value-key": "preference_id"
    },
    model: {
      value: (_vm.model.hba1c),
      callback: function($$v) {
        _vm.$set(_vm.model, "hba1c", $$v)
      },
      expression: "model.hba1c"
    }
  }), _vm._v(" "), _c('tab-selector', {
    attrs: {
      "label": _vm.$t('message.unitsPreferencesMeasureBloodGlucose'),
      "list": _vm.bindings.blood_glucose,
      "text-key": "unit",
      "value-key": "preference_id"
    },
    model: {
      value: (_vm.model.blood_glucose),
      callback: function($$v) {
        _vm.$set(_vm.model, "blood_glucose", $$v)
      },
      expression: "model.blood_glucose"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "disabled": _vm.isSaving,
      "secondary": "",
      "label": _vm.isSaving ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "316px"
    },
    attrs: {
      "justify": "center center",
      "align": "center center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 46
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-274157cb","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Settings/Units.vue
// module id = 3090
// module chunks = 1